import { isRef, type ComputedRef, type Ref } from 'vue'
import { isFunction } from 'es-toolkit'

export type RefOrGetter<T = any> = Ref<T> | ComputedRef<T> | (() => T)

/**
 * Checks if value is a ref, computed or a function with no parameters.
 *
 * I.e. this function is the runtime equivalent to the MaybeRefOrGetter type from vue.
 */
export function isRefOrGetter<T = unknown>(value: T): value is Extract<T, RefOrGetter> {
    return isRef(value) || (isFunction(value) && value.length === 0)
}
